export enum SkeletonVariant {
  Button = "button",
  Badge = "badge",
  Text = "text",
}
